import type { ErrorCode } from './codes';

export interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  code: ErrorCode | string;
  traceId?: string;
  errors?: Record<string, string[]>;
}

/**
 * Typed error thrown by the shared axios response interceptor when the server
 * returns application/problem+json. Consumers branch on `err.code` / `err.status`
 * rather than hand-parsing `err.response.data`.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly title: string;
  readonly detail?: string;
  readonly traceId?: string;
  readonly fieldErrors?: Record<string, string[]>;
  readonly raw: ProblemDetails;

  constructor(problem: ProblemDetails) {
    super(problem.title || 'API error');
    this.name = 'ApiError';
    this.status = problem.status;
    this.code = problem.code;
    this.title = problem.title;
    this.detail = problem.detail;
    this.traceId = problem.traceId;
    this.fieldErrors = problem.errors;
    this.raw = problem;
  }

  is(code: ErrorCode | string): boolean {
    return this.code === code;
  }
}
